import { icons } from "@a365/dsys";
import React, { useEffect } from "react";
import { useIsMobile, useBreakpointDown } from "@a365/core";

const { SealPercent } = icons;

const BannerCard = ({ bannerData }) => {

  const isMobile = useIsMobile();
  const isMd = useBreakpointDown("md");

  return (
    <div className="overflow-hidden relative z-10 text-wrap w-full xl:w-[486px] xl:min-w-[486px] max-w-[358px] md:max-w-full h-auto lg:h-[108px] xl:h-[280px] rounded-2xl bg-brand-comp-lilac p-4 xl:p-6 flex xl:items-start xl:justify-center flex-row xl:flex-col space-y-1">
      <SealPercent
        size={isMobile && isMd ? 32 : 48}
        weight="duotone"
        className="text-icon-darker xl:mb-8 mr-4"
      />

      <div className="flex flex-col">
        <span className="text-text-default text-base xl:text-xl font-semibold leading-6">
          {bannerData?.slide_1?.left?.vigencia}
        </span>
        <span className="text-text-default text-2xl xl:text-4xl font-semibold leading-8 xl:leading-10">
          {bannerData?.slide_1?.left?.promo}
        </span>
        <span className="text-sm xl:text-xl text-text-default leading-6">
          {bannerData?.slide_1?.left?.disclaimer}
        </span>
      </div>

      <div
        className="
      bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/shape3.svg')]
      absolute bg-contain bg-right-top bg-no-repeat !w-[196px] !h-[300px] right-0 top-0 z-5"></div>

      {/* <div className="absolute w-[196px] h-[280px] right-0 top-0 z-5 overflow-hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="197"
          height="280"
          viewBox="0 0 197 280"
          fill="none"
        >
          <path
            d="M9.06355 180.628C-12.2101 229.82 10.8266 270.05 27.5681 286.919C29.611 288.978 32.441 290 35.3411 290H184.5C191.127 290 196.5 284.627 196.5 278V1.68216C196.5 -4.81665 191.27 -9.98978 184.969 -8.39721C172.472 -5.23833 153.795 3.19103 134.461 22.0383C100.802 54.85 99.7734 65.5853 103.788 79.8414C110.058 102.106 146.341 105.63 134.461 132.973C125.306 154.045 107.25 148.777 98.4645 143.008C97.8138 142.58 97.1607 142.188 96.4453 141.881C75.9149 133.075 31.3762 129.033 9.06355 180.628Z"
            fill="#515A60"
            fill-opacity="0.06"
          />
        </svg>
      </div> */}
    </div>
  );
};

export default BannerCard;

// Re-export the default component as named export for compatibility
export { BannerCard };

// Re-export other BannerCard variants
export { default as BannerCard2 } from './BannerCard2';
export { default as BannerCard3 } from './BannerCard3';
export { default as BannerCard4 } from './BannerCard4';
export { default as BannerCard5 } from './BannerCard5';
